import { render, staticRenderFns } from "./ListAddProducts.vue?vue&type=template&id=163e6540"
import script from "./ListAddProducts.vue?vue&type=script&lang=js"
export * from "./ListAddProducts.vue?vue&type=script&lang=js"
import style0 from "./ListAddProducts.vue?vue&type=style&index=0&id=163e6540&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163e6540')) {
      api.createRecord('163e6540', component.options)
    } else {
      api.reload('163e6540', component.options)
    }
    module.hot.accept("./ListAddProducts.vue?vue&type=template&id=163e6540", function () {
      api.rerender('163e6540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ListAddProducts.vue"
export default component.exports